import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export interface SeletorDestinatarios {
  id: number;
  nome: string;
  descricao?: string;
  active: number;
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Lista todos os seletores ativos.
 */
export const listarSeletoresAtivosService = async (): Promise<SeletorDestinatarios[] | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/seletor-destinatarios/ativos`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao listar seletores ativos:", error);
    }
  }
};

/**
 * (opcional) Lista todos os seletores, ativos e inativos.
 */
export const listarTodosSeletoresService = async (): Promise<SeletorDestinatarios[] | undefined> => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/seletor-destinatarios`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error("Erro ao listar seletores:", error);
    }
  }
};

// 🔹 Exporta o objeto com as funções (boa prática)
export const seletorDestinatariosService = {
  listarSeletoresAtivosService,
  listarTodosSeletoresService,
};
